var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_314_12549",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_314_12549)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mail_2",
    d: "M4.61538 19C4.15513 19 3.77083 18.8458 3.4625 18.5375C3.15417 18.2292 3 17.8449 3 17.3846V6.61537C3 6.15512 3.15417 5.77083 3.4625 5.4625C3.77083 5.15417 4.15513 5 4.61538 5H19.3846C19.8449 5 20.2292 5.15417 20.5375 5.4625C20.8458 5.77083 21 6.15512 21 6.61537V17.3846C21 17.8449 20.8458 18.2292 20.5375 18.5375C20.2292 18.8458 19.8449 19 19.3846 19H4.61538ZM12 12.1154L4 6.88463V17.3846C4 17.5641 4.05769 17.7115 4.17308 17.8269C4.28846 17.9423 4.43589 18 4.61538 18H19.3846C19.5641 18 19.7115 17.9423 19.8269 17.8269C19.9423 17.7115 20 17.5641 20 17.3846V6.88463L12 12.1154ZM12 11L19.6923 6H4.3077L12 11ZM4 6.88463V6V17.3846C4 17.5641 4.05769 17.7115 4.17308 17.8269C4.28846 17.9423 4.43589 18 4.61538 18H4V6.88463Z",
    fill: "#15B79E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.21193bd7c45f17458b0715cb38509f26.svg";
export { ForwardRef as ReactComponent };